/**
 * @generated SignedSource<<bbbc170be04b06d440fbf69434672653>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerQueriesImagesCategoriesQuery$variables = {
  isLibrary: boolean;
  onlybackground: boolean;
};
export type composerQueriesImagesCategoriesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"composerQueriesImagesGalleryImagesQueriesCategories_fragment" | "composerQueriesImagesMacroQueriesCategories_fragment">;
};
export type composerQueriesImagesCategoriesQuery = {
  response: composerQueriesImagesCategoriesQuery$data;
  variables: composerQueriesImagesCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLibrary"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onlybackground"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystemwide",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfProducts",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referenceKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesImagesCategoriesQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "composerQueriesImagesMacroQueriesCategories_fragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "composerQueriesImagesGalleryImagesQueriesCategories_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "composerQueriesImagesCategoriesQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "isLibrary",
            "variableName": "isLibrary"
          },
          {
            "kind": "Variable",
            "name": "onlybackground",
            "variableName": "onlybackground"
          }
        ],
        "concreteType": "ImageMacroCategory",
        "kind": "LinkedField",
        "name": "imageMacroCategories",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "onlyForBackgrounds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "macroCategoryPosition",
            "storageKey": null
          },
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryPosition",
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0cf8e0c71ab27dba252ae5d70834ae96",
    "id": null,
    "metadata": {},
    "name": "composerQueriesImagesCategoriesQuery",
    "operationKind": "query",
    "text": "query composerQueriesImagesCategoriesQuery(\n  $onlybackground: Boolean!\n  $isLibrary: Boolean!\n) {\n  ...composerQueriesImagesMacroQueriesCategories_fragment\n  ...composerQueriesImagesGalleryImagesQueriesCategories_fragment\n}\n\nfragment composerQueriesImagesGalleryImagesQueriesCategories_fragment on Query {\n  imageMacroCategories(onlybackground: $onlybackground, isLibrary: $isLibrary) {\n    id\n    name\n    hasImages\n    isSystemwide\n    numberOfProducts\n    onlyForBackgrounds\n    macroCategoryPosition\n    categories {\n      id\n      name\n      hasImages\n      isSystemwide\n      numberOfProducts\n      categoryPosition\n    }\n  }\n}\n\nfragment composerQueriesImagesMacroQueriesCategories_fragment on Query {\n  imageMacroCategories(onlybackground: $onlybackground, isLibrary: $isLibrary) {\n    id\n    name\n    hasImages\n    isSystemwide\n    numberOfProducts\n    onlyForBackgrounds\n    macroCategoryPosition\n    referenceKey\n    categories {\n      id\n      name\n      hasImages\n      isSystemwide\n      numberOfProducts\n      categoryPosition\n      referenceKey\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2488eae1c85003e5c0de9c36fb704015";

export default node;
